import { Button } from "@xola/ui-kit";
import React, { ComponentProps } from "react";

interface CheckoutButtonProps extends ComponentProps<"button"> {
    label?: string;
}

export const CheckoutButton = ({ label = "Checkout", ...rest }: CheckoutButtonProps) => {
    return (
        <Button data-testid="create-purchase-screen-checkout-button" {...rest}>
            {label}
        </Button>
    );
};
